<template>
  <pt-obs-department-detail class="pt-obs-department-detail__withData" :id="id" :isEdit="isEdit" :data="data" @answerTheAsk="answerTheAsk"
  :loading="loading" :submitLoading="submitLoading" @answerRecordsBlock="answerRecordsBlock" @deleteRecord="deleteRecord" @closeASK="closeASK"
  @deleteQuestion="deleteQuestion" :userId="userId"></pt-obs-department-detail>
</template>

<script>
import PtObsDepartmentDetail from './index'
export default {
  name: 'pt-obs-department-detail__withData',
  components: {
    'pt-obs-department-detail': PtObsDepartmentDetail
  },
  props: {
    isEdit: Boolean,
    id: String
  },
  data () {
    return {
      data: {
      },
      loading: false,
      submitLoading: false,
      userId: null
    }
  },
  methods: {
    closeASK (id) {
      this.$store.dispatch('closeQuestion', id).then(res => {
        this.$message.success('关闭问题成功')
        this.getQstionAnswerDetail()
      }).catch(err => {
        this.$message.error(err || '关闭问题失败')
      })
    },
    deleteQuestion (id) {
      this.$store.dispatch('deleteQuestion', id).then(res => {
        this.$message.success('删除问题成功')
        this.getQstionAnswerDetail()
      }).catch(err => {
        this.$message.error(err || '删除问题失败')
      })
    },
    answerRecordsBlock (id) {
      this.$store.dispatch('answerRecordsBlock', id).then(res => {
        this.$message.success('屏蔽问答记录成功')
        this.getQstionAnswerDetail()
      }).catch(err => {
        this.$message.error(err || '屏蔽问答记录失败')
      })
    },
    deleteRecord (id) {
      this.$store.dispatch('deleteRecord', id).then(res => {
        this.$message.success('删除问答记录成功')
        this.getQstionAnswerDetail()
      }).catch(err => {
        this.$message.error(err || '删除问答记录失败')
      })
    },
    answerTheAsk (data) {
      this.submitLoading = true
      this.$store.dispatch('answerTheAsk', data).then(res => {
        this.$message.success('回答问题成功')
        this.getQstionAnswerDetail()
        this.submitLoading = false
      }).catch(err => {
        this.submitLoading = false
        this.$message.error(err || '回答问题失败')
      })
    },
    getQstionAnswerDetail () {
      this.loading = true
      this.$store.dispatch('getQstionAnswerDetail', this.id).then(res => {
        this.loading = false
        this.data = res
        let answererInfo = this.data.mainQuestion && this.data.mainQuestion.answererInfo
        if (answererInfo.userLogin) {
          this.getUserByLogin(answererInfo.userLogin)
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取问答详情失败')
      })
    },
    // 根据医生的userLogin获取医生的用户id
    getUserByLogin (userLogin) {
      this.$store.dispatch('getUserByLogin', userLogin).then(res => {
        this.userId = res.data.id
      }).catch(err => {
        console.log(err)
        // this.$message.error(err||'获取医生的用户信息失败')
      })
    }
  },
  created () {
    this.getQstionAnswerDetail()
  }
}
</script>
